module.exports = __webpack_public_path__ + "static/img/new-home-title.03ddb6c1.png";